import React from "react";
// Components
import HorizontalCard from "../generic/HorizontalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory } from "react-router-dom";

const CardAddLaico = styled(HorizontalCard)`
    background-color: antiquewhite;
    :hover {
        box-shadow: 0 0px 6px #876642 !important;
    }
`;

const LaicoAddTarjeta = ({ ...props }) => {

    let history = useHistory();

    let img = "/images/laicos_add.png";
    let imgOnError = img;
    let title = `Añadir un nuevo laico`;

    return (

        <CardAddLaico {...props} onClick={() => {
            history.push(`laicos/add`);
        }} cardImage={img} title={title} imgOnError={imgOnError} {...props}></CardAddLaico>
    );
};

export default LaicoAddTarjeta;
